module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-collector-4.9b10bc64.svg";